import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {EMERGENCY_CONTRACEPTION_KEYS, STI_TESTING_KEYS} from '~/constants/medical-questionnaires';
import {useNotification} from '~/hooks';
import {setBackQuestionnaire} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire3Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const {questionnaires} = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaire = questionnaires?.find(i => i.key === STI_TESTING_KEYS.INVALID);

  return (
    <UiQuestionnaireLayout actions={questionnaire?.actions}>
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.large} />
        <UiText fontSize="lg" fontWeight="bold" mt={spacing.xmedium}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText fontSize="sm" mt={spacing.xmedium} px={spacing.medium}>
          {questionnaire?.descriptions?.default}
        </UiText>
        <UiText fontSize="sm" mt={spacing.small} px={spacing.medium}>
          {questionnaire?.descriptions?.sub}
        </UiText>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire3Screen;
